import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import { SocialShare } from './SocialShare'

export type ShareGroupProps = {
  className?: string
  title: string
  text: string
  url: string
  children: React.ReactNode
  buttonLabel?: string
}

function ShareGroupComponent({
  className,
  title,
  text,
  url,
  children,
  buttonLabel,
}: ShareGroupProps): React.ReactElement<ShareGroupProps> {
  return (
    <ShareGroupWrapper className={className}>
      {children}
      <SocialShare url={url} title={title} text={text} buttonLabel={buttonLabel} />
    </ShareGroupWrapper>
  )
}

const ShareGroupWrapper = styled.div`
  background-color: ${plume.COLORS.PRIMARY_SAND};
  width: 100%;
  max-width: 624px;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin-top: 40px;
  }
`

export const ShareGroup = styled(ShareGroupComponent)``
